module.exports = {
      id: "key-registered-usage",
      viewBox: "0 0 86 86",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#key-registered",
      toString: function () {
        return this.url;
      }
    }